import type { HomeScreenTaskSuggestion } from '@frontend/react-domain';
import { Icon, Text, XStack, YStack } from '@frontend/web-react';

type SuggestionChipProps = {
  onPress: () => void;
  suggestion: HomeScreenTaskSuggestion;
};

export const SuggestionChip = ({ onPress, suggestion }: SuggestionChipProps) => (
  <XStack
    accessibilityLabel={`Select task suggestion: ${suggestion.shortenedLabel || suggestion.draftDescription}`}
    // eslint-disable-next-line tailwindcss/no-arbitrary-value
    className="rounded-[14px] border-1 border-cream-400 bg-trueWhite gap-[6px] items-center cursor-pointer hover:bg-cream-100 transition-colors max-w-[200px]"
    flexShrink={0}
    onClick={onPress}
    style={{ paddingBottom: 10, paddingLeft: 14, paddingRight: 10, paddingTop: 10 }}
  >
    <Text className="truncate flex-1" color="primary" type="p-sm">
      {suggestion.shortenedLabel || suggestion.draftDescription}
    </Text>
    {/* eslint-disable-next-line tailwindcss/no-arbitrary-value */}
    <YStack className="rounded-xs bg-cream-100 items-center justify-center shrink-0 size-[24px]">
      <Icon color="tertiary" name="IconArrowUpRight" size={12} />
    </YStack>
  </XStack>
);
